import { render, staticRenderFns } from "./MntQuestion.vue?vue&type=template&id=21072d7d"
import script from "./MntQuestion.vue?vue&type=script&lang=js"
export * from "./MntQuestion.vue?vue&type=script&lang=js"
import style0 from "./MntQuestion.vue?vue&type=style&index=0&id=21072d7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports